import { FormGroup } from "reactstrap";
import { Label } from "reactstrap";
import FileBase64 from 'react-file-base64';
import { IFile } from "../../../globals/interfaces";

export default function UploadAttachments({
    addAttachments
}: {
    addAttachments: (files: Array<IFile>) => void;
}) {
    return (
        <FormGroup>
            <Label className={'d-block'}>Upload Attachments</Label>
            <FileBase64
                multiple
                onDone={addAttachments}
            />
        </FormGroup>
    );
}